import React from "react"
import "./index.css"

export default () => (
    <div id="technologies">
        <div className="col-12 text-center my-5">
            <div className="pageTitle">Tech I use</div>
        </div>
        <div className="clouds p-5 w-100">
            <div className="x1">
                <i className="fab fa-react"></i>
            </div>
            <div className="x2">
                <i className="fab fa-html5"></i>
            </div>
            <div className="x3">
                <i className="fab fa-js-square"></i>
            </div>
            <div className="x4">
                <i className="fab fa-figma"></i>
            </div>
            <div className="x5">
                <i className="fab fa-node"></i>
            </div>
            <div className="x6">
                <i className="fab fa-css3-alt"></i>
            </div>
            <div className="x7">
                <i className="fab fa-sass"></i>
            </div>
        </div>
    </div>
)